import { Component, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { SetParagraph } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-paragraph',
  templateUrl: './sample-paragraph.component.html',
  styleUrls: ['./sample-paragraph.component.scss']
})
export class SampleParagraphComponent implements OnInit {

  @Input() block: SetParagraph[] = [];
  @Input() column: string = '';
  public domainWebsite = environment.urlApi;
  public classColumn: string = '';
  @HostListener('click', ['$event'])
  onClick(event: any) {
    this.helpersService.viewportScroll(event);
  }

  constructor(public helpersService: HelpersService, 
              private renderer: Renderer2) { }

  ngOnInit(): void {
    this.setColumnItem();
  }

  ngAfterViewInit(): void {
    this.helpersService.setStyleTables(this.renderer);
  }

  private setColumnItem() {
    if (this.column === '4') {
      this.classColumn = 'col-12 col-md-9 m-auto mb-5';
    } else {
      this.classColumn = 'col-12 mb-5';
    }
  };
}
